import { DossierVosOproepen as DossierVosOproepDto, VosOproep as VosOproepDto } from "@/shared/types";

// types and consts in this file are used with a debug admin endpoint

export type DossierVosOproep = {
    dossierId: number;
    omschrijving: string;
    omschrijvingExtraContext?: string;
    vosOproepen: Record<string, VosOproep[]>;
};

export const DossierVosOproep = {
    fromDto: (dto: DossierVosOproepDto): DossierVosOproep => ({
        dossierId: dto.dossierId,
        omschrijving: dto.omschrijving,
        omschrijvingExtraContext: dto.omschrijvingExtraContext,
        vosOproepen: Object.fromEntries(
            Object.entries(dto.vosOproepen ?? {}).map(([entraId, oproepen]) => [
                entraId,
                oproepen.map((oproep) => VosOproep.fromDto(oproep)),
            ])
        ),
    }),
    sort: (a: DossierVosOproep, b: DossierVosOproep): number => {
        return b.dossierId - a.dossierId;
    },
};

export type VosOproep = {
    entraId: string;
    geldigTot: string;
    id: string;
    opStation: string;
    status: "Aangevraagd" | "NietMeerNodig" | "Komt" | "KomtNiet" | "NietOproepbaar" | "Gestopt" | "AanvraagVerlopen";
};

export const VosOproep = {
    fromDto: (dto: VosOproepDto): VosOproep => ({
        entraId: dto.entraId,
        geldigTot: dto.geldigTot,
        id: dto.id,
        opStation: dto.opStation,
        status: dto.status,
    }),
    sort: (a: VosOproep, b: VosOproep): number => {
        return new Date(b.geldigTot).getTime() - new Date(a.geldigTot).getTime();
    },
};
